import { Trans } from "@lingui/react/macro";
import React from "react";

import { Button } from "@/common/components/button/button";

const CropDetail = ({
  children,
  onSubmit,
  onDelete,
  tons = 0,
}: React.PropsWithChildren<{
  onDelete?: () => void;
  onSubmit: (tons: number) => void;
  tons: number;
}>) => {
  const [cropTons, setCropTons] = React.useState(tons);
  return (
    <form
      className="flex grow flex-col gap-y-4"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(cropTons);
      }}
    >
      {children}
      <label htmlFor="name">
        <Trans>Skladem (tun)</Trans>
        <input
          autoComplete="off"
          className="mt-2 block w-full rounded-lg border p-4 font-bold"
          id="name"
          min={1}
          onChange={(e) => setCropTons(e.target.valueAsNumber)}
          required
          type="number"
          value={cropTons}
        />
      </label>
      <Button.Container>
        {onDelete ? (
          <Button.Delete onClick={onDelete}>
            <Trans>Smazat komoditu</Trans>
          </Button.Delete>
        ) : null}

        <Button type="submit" variant="primary">
          <Trans>Uložit</Trans>
        </Button>
      </Button.Container>
    </form>
  );
};

export { CropDetail };
